/* tslint:disable */
/* eslint-disable */
/**
 * @b-stock/location
 * Location service
 *
 * The version of the OpenAPI document: 14.4.8
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AddressType = {
    Unknown: 'UNKNOWN',
    Residential: 'RESIDENTIAL',
    Commercial: 'COMMERCIAL'
};
/**
 * Enum container type
 */
export const ContainerType = {
    Pallet: 'PALLET',
    Parcel: 'PARCEL'
};
export const CountryFields = {
    Name: 'name',
    Regions: 'regions',
    Status: 'status',
    AllowOnboarding: 'allowOnboarding',
    Timezones: 'timezones',
    Brid: 'brid',
    Postcode: 'postcode',
    TaxExemption: 'taxExemption',
    CanExcludePostalCode: 'canExcludePostalCode'
};
export const Deliverability = {
    Deliverable: 'DELIVERABLE',
    DeliverableMissingInfo: 'DELIVERABLE_MISSING_INFO',
    Undeliverable: 'UNDELIVERABLE'
};
/**
 * Provided by value for a document
 */
export const DocumentProvidedBy = {
    Generated: 'GENERATED',
    Uploaded: 'UPLOADED'
};
export const DocumentSource = {
    Input: 'INPUT',
    Signature: 'SIGNATURE',
    Upload: 'UPLOAD',
    Generated: 'GENERATED'
};
/**
 * Status of a document
 */
export const DocumentStatus = {
    Valid: 'VALID',
    Waived: 'WAIVED',
    Exempt: 'EXEMPT',
    Expired: 'EXPIRED',
    Validating: 'VALIDATING',
    Pending: 'PENDING',
    Indeterminate: 'INDETERMINATE',
    Failed: 'FAILED',
    Invalid: 'INVALID',
    NotProvided: 'NOT_PROVIDED',
    Withdrawn: 'WITHDRAWN'
};
/**
 * The source of a status of a document
 */
export const DocumentStatusSource = {
    Manual: 'MANUAL',
    Service: 'SERVICE'
};
export const DocumentTemplate = {
    UsSsutac: 'US_SSUTAC',
    UsUsutcm: 'US_USUTCM',
    St120: 'ST_120',
    St10: 'ST_10',
    St5: 'ST_5',
    St4: 'ST_4',
    St3: 'ST_3'
};
/**
 * The document type
 */
export const DocumentType = {
    Vat: 'VAT',
    Gst: 'GST',
    Hst: 'HST',
    Crn: 'CRN',
    Fein: 'FEIN',
    ProvincialTaxNumber: 'PROVINCIAL_TAX_NUMBER',
    ProvincialTaxPostcode: 'PROVINCIAL_TAX_POSTCODE',
    ResaleCertificate: 'RESALE_CERTIFICATE',
    BusinessRegistration: 'BUSINESS_REGISTRATION',
    FfBusinessRegistration: 'FF_BUSINESS_REGISTRATION',
    FreightForwarder: 'FREIGHT_FORWARDER',
    Signature: 'SIGNATURE',
    R2Certificate: 'R2_CERTIFICATE',
    Brid: 'BRID',
    BridBusinessRegistration: 'BRID_BUSINESS_REGISTRATION'
};
export const LimitedLocationsOutputResponseTypeEnum = {
    Limited: 'LIMITED'
};
/**
 * Boolean array of location attributes - when present, true
 */
export const LocationAttribute = {
    Billable: 'BILLABLE',
    Deliverable: 'DELIVERABLE',
    Shippable: 'SHIPPABLE',
    LiftgateRequired: 'LIFTGATE_REQUIRED',
    DefaultBillable: 'DEFAULT_BILLABLE',
    DefaultDeliverable: 'DEFAULT_DELIVERABLE',
    DefaultShippable: 'DEFAULT_SHIPPABLE',
    Normalized: 'NORMALIZED',
    AllowedBuyerPickup: 'ALLOWED_BUYER_PICKUP',
    AllowedBuyerArranged: 'ALLOWED_BUYER_ARRANGED',
    AllowedFreeShipping: 'ALLOWED_FREE_SHIPPING',
    AllowedFlatRate: 'ALLOWED_FLAT_RATE',
    StorageUnitFacility: 'STORAGE_UNIT_FACILITY',
    CanUnloadTrucks: 'CAN_UNLOAD_TRUCKS',
    Can53FootTruck: 'CAN_53_FOOT_TRUCK'
};
export const LocationStatus = {
    Allowed: 'ALLOWED',
    NoExemptions: 'NO_EXEMPTIONS',
    Blocked: 'BLOCKED',
    Sanctioned: 'SANCTIONED'
};
/**
 * Type of location
 */
export const LocationType = {
    Business: 'BUSINESS',
    Residential: 'RESIDENTIAL',
    FreightForwarder: 'FREIGHT_FORWARDER'
};
export const LocationsOutputResponseTypeEnum = {
    Full: 'FULL'
};
export const PaginationOrder = {
    Asc: 'asc',
    Desc: 'desc'
};
export const SchedulePreference = {
    Anytime: 'ANYTIME',
    Notify: 'NOTIFY',
    ContactFirst: 'CONTACT_FIRST'
};
export const TaxExemptionStatus = {
    Valid: 'VALID',
    Expired: 'EXPIRED',
    Exempt: 'EXEMPT',
    Validating: 'VALIDATING',
    Pending: 'PENDING',
    Indeterminate: 'INDETERMINATE',
    Failed: 'FAILED',
    Invalid: 'INVALID',
    NotProvided: 'NOT_PROVIDED',
    NoExemptions: 'NO_EXEMPTIONS',
    IncompleteLocation: 'INCOMPLETE_LOCATION',
    Withdrawn: 'WITHDRAWN',
    Waived: 'WAIVED'
};
export const TaxExemptionType = {
    TaxExemption: 'TAX_EXEMPTION',
    FreightForwarder: 'FREIGHT_FORWARDER',
    Brid: 'BRID'
};
/**
 * AddressesApi - axios parameter creator
 */
export const AddressesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves address details. Currently, only US ZIP codes are supported, returning location coordinates
         * @summary Get address details
         * @param {string} zip Must be a valid zip code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressDetails: async (zip, options = {}) => {
            // verify required parameter 'zip' is not null or undefined
            assertParamExists('addressDetails', 'zip', zip);
            const localVarPath = `/addresses/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (zip !== undefined) {
                localVarQueryParameter['zip'] = zip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates/normalizes address data via [Lob api](https://www.lob.com). Must provide one of:       countryCode + primaryLine + city + provinceCode     countryCode + primaryLine + zipCode
         * @summary Validate address
         * @param {string} countryCode Must be a 2 letter country short-name code (ISO 3166)
         * @param {string} primaryLine The primary delivery line (usually the street address) of the address.
         * @param {string} [secondaryLine] The secondary delivery line of the address. This field is typically empty but may contain information if primaryLine is too long.
         * @param {string} [urbanization] Only present for addresses in Puerto Rico. An urbanization refers to an area, sector, or development within a city.
         * @param {string} [city] The name of the city. ***Required if no zipCode is passed.**
         * @param {string} [provinceCode] The [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) two letter (or, in some cases, one letter) code  or subdivision name for the state.  ***Required if no zipCode is passed.**
         * @param {string} [zipCode] Zip code. ***Required if city and provinceCode are not passed in.**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (countryCode, primaryLine, secondaryLine, urbanization, city, provinceCode, zipCode, options = {}) => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('validateAddress', 'countryCode', countryCode);
            // verify required parameter 'primaryLine' is not null or undefined
            assertParamExists('validateAddress', 'primaryLine', primaryLine);
            const localVarPath = `/addresses/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            if (primaryLine !== undefined) {
                localVarQueryParameter['primaryLine'] = primaryLine;
            }
            if (secondaryLine !== undefined) {
                localVarQueryParameter['secondaryLine'] = secondaryLine;
            }
            if (urbanization !== undefined) {
                localVarQueryParameter['urbanization'] = urbanization;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (provinceCode !== undefined) {
                localVarQueryParameter['provinceCode'] = provinceCode;
            }
            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AddressesApi - functional programming interface
 */
export const AddressesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves address details. Currently, only US ZIP codes are supported, returning location coordinates
         * @summary Get address details
         * @param {string} zip Must be a valid zip code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressDetails(zip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressDetails(zip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressesApi.addressDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates/normalizes address data via [Lob api](https://www.lob.com). Must provide one of:       countryCode + primaryLine + city + provinceCode     countryCode + primaryLine + zipCode
         * @summary Validate address
         * @param {string} countryCode Must be a 2 letter country short-name code (ISO 3166)
         * @param {string} primaryLine The primary delivery line (usually the street address) of the address.
         * @param {string} [secondaryLine] The secondary delivery line of the address. This field is typically empty but may contain information if primaryLine is too long.
         * @param {string} [urbanization] Only present for addresses in Puerto Rico. An urbanization refers to an area, sector, or development within a city.
         * @param {string} [city] The name of the city. ***Required if no zipCode is passed.**
         * @param {string} [provinceCode] The [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) two letter (or, in some cases, one letter) code  or subdivision name for the state.  ***Required if no zipCode is passed.**
         * @param {string} [zipCode] Zip code. ***Required if city and provinceCode are not passed in.**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(countryCode, primaryLine, secondaryLine, urbanization, city, provinceCode, zipCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAddress(countryCode, primaryLine, secondaryLine, urbanization, city, provinceCode, zipCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressesApi.validateAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AddressesApi - factory interface
 */
export const AddressesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AddressesApiFp(configuration);
    return {
        /**
         * Retrieves address details. Currently, only US ZIP codes are supported, returning location coordinates
         * @summary Get address details
         * @param {AddressesApiAddressDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressDetails(requestParameters, options) {
            return localVarFp.addressDetails(requestParameters.zip, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates/normalizes address data via [Lob api](https://www.lob.com). Must provide one of:       countryCode + primaryLine + city + provinceCode     countryCode + primaryLine + zipCode
         * @summary Validate address
         * @param {AddressesApiValidateAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(requestParameters, options) {
            return localVarFp.validateAddress(requestParameters.countryCode, requestParameters.primaryLine, requestParameters.secondaryLine, requestParameters.urbanization, requestParameters.city, requestParameters.provinceCode, requestParameters.zipCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddressesApi - object-oriented interface
 */
export class AddressesApi extends BaseAPI {
    /**
     * Retrieves address details. Currently, only US ZIP codes are supported, returning location coordinates
     * @summary Get address details
     * @param {AddressesApiAddressDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressDetails(requestParameters, options) {
        return AddressesApiFp(this.configuration).addressDetails(requestParameters.zip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validates/normalizes address data via [Lob api](https://www.lob.com). Must provide one of:       countryCode + primaryLine + city + provinceCode     countryCode + primaryLine + zipCode
     * @summary Validate address
     * @param {AddressesApiValidateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateAddress(requestParameters, options) {
        return AddressesApiFp(this.configuration).validateAddress(requestParameters.countryCode, requestParameters.primaryLine, requestParameters.secondaryLine, requestParameters.urbanization, requestParameters.city, requestParameters.provinceCode, requestParameters.zipCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CountriesApi - axios parameter creator
 */
export const CountriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options = {}) => {
            const localVarPath = `/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CountriesApi - functional programming interface
 */
export const CountriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountriesApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CountriesApi - factory interface
 */
export const CountriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CountriesApiFp(configuration);
    return {
        /**
         *
         * @summary Get all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options) {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CountriesApi - object-oriented interface
 */
export class CountriesApi extends BaseAPI {
    /**
     *
     * @summary Get all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountries(options) {
        return CountriesApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentsApi - axios parameter creator
 */
export const DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Stores to 🌱MongoDb instance using Mongoose schema modeling  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Adding request data to documents model
         * @param {FullUpdateDto} fullUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: async (fullUpdateDto, options = {}) => {
            // verify required parameter 'fullUpdateDto' is not null or undefined
            assertParamExists('createDocument', 'fullUpdateDto', fullUpdateDto);
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fullUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates order resale certificate
         * @param {OrderCertificateDto} orderCertificateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderResaleCertificate: async (orderCertificateDto, options = {}) => {
            // verify required parameter 'orderCertificateDto' is not null or undefined
            assertParamExists('createOrderResaleCertificate', 'orderCertificateDto', orderCertificateDto);
            const localVarPath = `/documents/order-rc-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orderCertificateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates resale certificate
         * @param {Array<string>} locationIds Location ids
         * @param {string} accountId Account id
         * @param {string} [title] Title of user generating certificate
         * @param {File} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResaleCertificate: async (locationIds, accountId, title, image, options = {}) => {
            // verify required parameter 'locationIds' is not null or undefined
            assertParamExists('createResaleCertificate', 'locationIds', locationIds);
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createResaleCertificate', 'accountId', accountId);
            const localVarPath = `/documents/tax-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }
            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }
            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_DOCUMENT_WITHDRAWN_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary When a document record id is know return that document record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentById', 'id', id);
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get list of document items
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {Array<string>} [id] Document ids
         * @param {Array<string>} [prettyId] Pretty location id
         * @param {Array<string>} [accountId] Account record association
         * @param {Array<DocumentType>} [docType] The document type
         * @param {Array<string>} [countryCode] ISO 3166 Alpha-2 code of governing authority that document pertains to
         * @param {Array<string>} [provinceCode] Optional region
         * @param {Array<string>} [value] Identifier related to the type, for example the VAT number value
         * @param {Array<DocumentStatus>} [status] Status of a document
         * @param {Array<DocumentStatusSource>} [statusSource] The source of the status
         * @param {Array<string>} [enterpriseDocumentId] Document ids
         * @param {Array<string>} [locationOriginalId] One or many comma separated originalId of the location the document applies to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (limit, offset, id, prettyId, accountId, docType, countryCode, provinceCode, value, status, statusSource, enterpriseDocumentId, locationOriginalId, options = {}) => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (prettyId) {
                localVarQueryParameter['prettyId'] = prettyId;
            }
            if (accountId) {
                localVarQueryParameter['accountId'] = accountId;
            }
            if (docType) {
                localVarQueryParameter['docType'] = docType;
            }
            if (countryCode) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            if (provinceCode) {
                localVarQueryParameter['provinceCode'] = provinceCode;
            }
            if (value) {
                localVarQueryParameter['value'] = value;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (statusSource) {
                localVarQueryParameter['statusSource'] = statusSource;
            }
            if (enterpriseDocumentId) {
                localVarQueryParameter['enterpriseDocumentId'] = enterpriseDocumentId;
            }
            if (locationOriginalId) {
                localVarQueryParameter['locationOriginalId'] = locationOriginalId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Migrate multiple documents over from enterprise to 3mp
         * @param {Array<MigrateDocuments>} migrateDocuments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateDocuments: async (migrateDocuments, options = {}) => {
            // verify required parameter 'migrateDocuments' is not null or undefined
            assertParamExists('migrateDocuments', 'migrateDocuments', migrateDocuments);
            const localVarPath = `/documents/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(migrateDocuments, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_RESTRICTED_FIELDS_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating document fields
         * @param {string} id resource identifier - mongo id
         * @param {PartialUpdateDto} partialUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: async (id, partialUpdateDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocument', 'id', id);
            // verify required parameter 'partialUpdateDto' is not null or undefined
            assertParamExists('updateDocument', 'partialUpdateDto', partialUpdateDto);
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates a tax id before being able to save
         * @summary Validates document
         * @param {string} state
         * @param {string} value Identifier related to the type, for example the VAT number value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxId: async (state, value, options = {}) => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('validateTaxId', 'state', state);
            // verify required parameter 'value' is not null or undefined
            assertParamExists('validateTaxId', 'value', value);
            const localVarPath = `/documents/validate/{state}`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentsApi - functional programming interface
 */
export const DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Stores to 🌱MongoDb instance using Mongoose schema modeling  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Adding request data to documents model
         * @param {FullUpdateDto} fullUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocument(fullUpdateDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocument(fullUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Creates order resale certificate
         * @param {OrderCertificateDto} orderCertificateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderResaleCertificate(orderCertificateDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderResaleCertificate(orderCertificateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createOrderResaleCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Creates resale certificate
         * @param {Array<string>} locationIds Location ids
         * @param {string} accountId Account id
         * @param {string} [title] Title of user generating certificate
         * @param {File} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResaleCertificate(locationIds, accountId, title, image, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createResaleCertificate(locationIds, accountId, title, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createResaleCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_DOCUMENT_WITHDRAWN_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary When a document record id is know return that document record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get list of document items
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {Array<string>} [id] Document ids
         * @param {Array<string>} [prettyId] Pretty location id
         * @param {Array<string>} [accountId] Account record association
         * @param {Array<DocumentType>} [docType] The document type
         * @param {Array<string>} [countryCode] ISO 3166 Alpha-2 code of governing authority that document pertains to
         * @param {Array<string>} [provinceCode] Optional region
         * @param {Array<string>} [value] Identifier related to the type, for example the VAT number value
         * @param {Array<DocumentStatus>} [status] Status of a document
         * @param {Array<DocumentStatusSource>} [statusSource] The source of the status
         * @param {Array<string>} [enterpriseDocumentId] Document ids
         * @param {Array<string>} [locationOriginalId] One or many comma separated originalId of the location the document applies to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(limit, offset, id, prettyId, accountId, docType, countryCode, provinceCode, value, status, statusSource, enterpriseDocumentId, locationOriginalId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(limit, offset, id, prettyId, accountId, docType, countryCode, provinceCode, value, status, statusSource, enterpriseDocumentId, locationOriginalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Migrate multiple documents over from enterprise to 3mp
         * @param {Array<MigrateDocuments>} migrateDocuments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateDocuments(migrateDocuments, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateDocuments(migrateDocuments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.migrateDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_RESTRICTED_FIELDS_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating document fields
         * @param {string} id resource identifier - mongo id
         * @param {PartialUpdateDto} partialUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocument(id, partialUpdateDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument(id, partialUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.updateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates a tax id before being able to save
         * @summary Validates document
         * @param {string} state
         * @param {string} value Identifier related to the type, for example the VAT number value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTaxId(state, value, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTaxId(state, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.validateTaxId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocumentsApi - factory interface
 */
export const DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentsApiFp(configuration);
    return {
        /**
         * Stores to 🌱MongoDb instance using Mongoose schema modeling  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Adding request data to documents model
         * @param {DocumentsApiCreateDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(requestParameters, options) {
            return localVarFp.createDocument(requestParameters.fullUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates order resale certificate
         * @param {DocumentsApiCreateOrderResaleCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderResaleCertificate(requestParameters, options) {
            return localVarFp.createOrderResaleCertificate(requestParameters.orderCertificateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates resale certificate
         * @param {DocumentsApiCreateResaleCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResaleCertificate(requestParameters, options) {
            return localVarFp.createResaleCertificate(requestParameters.locationIds, requestParameters.accountId, requestParameters.title, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_DOCUMENT_WITHDRAWN_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary When a document record id is know return that document record
         * @param {DocumentsApiGetDocumentByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentById(requestParameters, options) {
            return localVarFp.getDocumentById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of document items
         * @param {DocumentsApiGetDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(requestParameters = {}, options) {
            return localVarFp.getDocuments(requestParameters.limit, requestParameters.offset, requestParameters.id, requestParameters.prettyId, requestParameters.accountId, requestParameters.docType, requestParameters.countryCode, requestParameters.provinceCode, requestParameters.value, requestParameters.status, requestParameters.statusSource, requestParameters.enterpriseDocumentId, requestParameters.locationOriginalId, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Migrate multiple documents over from enterprise to 3mp
         * @param {DocumentsApiMigrateDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateDocuments(requestParameters, options) {
            return localVarFp.migrateDocuments(requestParameters.migrateDocuments, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_RESTRICTED_FIELDS_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating document fields
         * @param {DocumentsApiUpdateDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(requestParameters, options) {
            return localVarFp.updateDocument(requestParameters.id, requestParameters.partialUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates a tax id before being able to save
         * @summary Validates document
         * @param {DocumentsApiValidateTaxIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTaxId(requestParameters, options) {
            return localVarFp.validateTaxId(requestParameters.state, requestParameters.value, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Stores to 🌱MongoDb instance using Mongoose schema modeling  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Adding request data to documents model
     * @param {DocumentsApiCreateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDocument(requestParameters, options) {
        return DocumentsApiFp(this.configuration).createDocument(requestParameters.fullUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates order resale certificate
     * @param {DocumentsApiCreateOrderResaleCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrderResaleCertificate(requestParameters, options) {
        return DocumentsApiFp(this.configuration).createOrderResaleCertificate(requestParameters.orderCertificateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates resale certificate
     * @param {DocumentsApiCreateResaleCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResaleCertificate(requestParameters, options) {
        return DocumentsApiFp(this.configuration).createResaleCertificate(requestParameters.locationIds, requestParameters.accountId, requestParameters.title, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_DOCUMENT_WITHDRAWN_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary When a document record id is know return that document record
     * @param {DocumentsApiGetDocumentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentById(requestParameters, options) {
        return DocumentsApiFp(this.configuration).getDocumentById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of document items
     * @param {DocumentsApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocuments(requestParameters = {}, options) {
        return DocumentsApiFp(this.configuration).getDocuments(requestParameters.limit, requestParameters.offset, requestParameters.id, requestParameters.prettyId, requestParameters.accountId, requestParameters.docType, requestParameters.countryCode, requestParameters.provinceCode, requestParameters.value, requestParameters.status, requestParameters.statusSource, requestParameters.enterpriseDocumentId, requestParameters.locationOriginalId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_CREATE   * **Subroles:** BACKEND, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_SKIP_TAX_FIELD_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_STATUS_CREATE   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Migrate multiple documents over from enterprise to 3mp
     * @param {DocumentsApiMigrateDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateDocuments(requestParameters, options) {
        return DocumentsApiFp(this.configuration).migrateDocuments(requestParameters.migrateDocuments, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_DOCUMENT_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_DOCUMENT_RESTRICTED_FIELDS_UPDATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Updating document fields
     * @param {DocumentsApiUpdateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocument(requestParameters, options) {
        return DocumentsApiFp(this.configuration).updateDocument(requestParameters.id, requestParameters.partialUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validates a tax id before being able to save
     * @summary Validates document
     * @param {DocumentsApiValidateTaxIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateTaxId(requestParameters, options) {
        return DocumentsApiFp(this.configuration).validateTaxId(requestParameters.state, requestParameters.value, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventPublisherApi - axios parameter creator
 */
export const EventPublisherApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.created event
         * @param {NotificationContentDto} notificationContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPublisherControllerPublishLocationCreated: async (notificationContentDto, options = {}) => {
            // verify required parameter 'notificationContentDto' is not null or undefined
            assertParamExists('eventPublisherControllerPublishLocationCreated', 'notificationContentDto', notificationContentDto);
            const localVarPath = `/event-publisher/publish-location-created`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(notificationContentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.updated event
         * @param {NotificationContentDto} notificationContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPublisherControllerPublishLocationUpdated: async (notificationContentDto, options = {}) => {
            // verify required parameter 'notificationContentDto' is not null or undefined
            assertParamExists('eventPublisherControllerPublishLocationUpdated', 'notificationContentDto', notificationContentDto);
            const localVarPath = `/event-publisher/publish-location-updated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(notificationContentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventPublisherApi - functional programming interface
 */
export const EventPublisherApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventPublisherApiAxiosParamCreator(configuration);
    return {
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.created event
         * @param {NotificationContentDto} notificationContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventPublisherControllerPublishLocationCreated(notificationContentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventPublisherControllerPublishLocationCreated(notificationContentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventPublisherApi.eventPublisherControllerPublishLocationCreated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.updated event
         * @param {NotificationContentDto} notificationContentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventPublisherControllerPublishLocationUpdated(notificationContentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventPublisherControllerPublishLocationUpdated(notificationContentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventPublisherApi.eventPublisherControllerPublishLocationUpdated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EventPublisherApi - factory interface
 */
export const EventPublisherApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventPublisherApiFp(configuration);
    return {
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.created event
         * @param {EventPublisherApiEventPublisherControllerPublishLocationCreatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPublisherControllerPublishLocationCreated(requestParameters, options) {
            return localVarFp.eventPublisherControllerPublishLocationCreated(requestParameters.notificationContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To assist with standalone testing this endpoint is provided as a convenience.
         * @summary Simulates evt.location.location.updated event
         * @param {EventPublisherApiEventPublisherControllerPublishLocationUpdatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPublisherControllerPublishLocationUpdated(requestParameters, options) {
            return localVarFp.eventPublisherControllerPublishLocationUpdated(requestParameters.notificationContentDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventPublisherApi - object-oriented interface
 */
export class EventPublisherApi extends BaseAPI {
    /**
     * To assist with standalone testing this endpoint is provided as a convenience.
     * @summary Simulates evt.location.location.created event
     * @param {EventPublisherApiEventPublisherControllerPublishLocationCreatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventPublisherControllerPublishLocationCreated(requestParameters, options) {
        return EventPublisherApiFp(this.configuration).eventPublisherControllerPublishLocationCreated(requestParameters.notificationContentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * To assist with standalone testing this endpoint is provided as a convenience.
     * @summary Simulates evt.location.location.updated event
     * @param {EventPublisherApiEventPublisherControllerPublishLocationUpdatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventPublisherControllerPublishLocationUpdated(requestParameters, options) {
        return EventPublisherApiFp(this.configuration).eventPublisherControllerPublishLocationUpdated(requestParameters.notificationContentDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExemptionRequirementsApi - axios parameter creator
 */
export const ExemptionRequirementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get exemption requirements for country
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {Array<CountryFields>} [fields] List of top-level fields to return. If specified, only the listed fields will be returned and all otherwise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryRequirements: async (country, fields, options = {}) => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getCountryRequirements', 'country', country);
            const localVarPath = `/exemption-requirements/{country}`
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get exemption requirements for region
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionRequirements: async (country, region, options = {}) => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getRegionRequirements', 'country', country);
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getRegionRequirements', 'region', region);
            const localVarPath = `/exemption-requirements/{country}/{region}`
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExemptionRequirementsApi - functional programming interface
 */
export const ExemptionRequirementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExemptionRequirementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get exemption requirements for country
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {Array<CountryFields>} [fields] List of top-level fields to return. If specified, only the listed fields will be returned and all otherwise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryRequirements(country, fields, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryRequirements(country, fields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionRequirementsApi.getCountryRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get exemption requirements for region
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegionRequirements(country, region, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegionRequirements(country, region, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionRequirementsApi.getRegionRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ExemptionRequirementsApi - factory interface
 */
export const ExemptionRequirementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExemptionRequirementsApiFp(configuration);
    return {
        /**
         *
         * @summary Get exemption requirements for country
         * @param {ExemptionRequirementsApiGetCountryRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryRequirements(requestParameters, options) {
            return localVarFp.getCountryRequirements(requestParameters.country, requestParameters.fields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get exemption requirements for region
         * @param {ExemptionRequirementsApiGetRegionRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionRequirements(requestParameters, options) {
            return localVarFp.getRegionRequirements(requestParameters.country, requestParameters.region, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExemptionRequirementsApi - object-oriented interface
 */
export class ExemptionRequirementsApi extends BaseAPI {
    /**
     *
     * @summary Get exemption requirements for country
     * @param {ExemptionRequirementsApiGetCountryRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountryRequirements(requestParameters, options) {
        return ExemptionRequirementsApiFp(this.configuration).getCountryRequirements(requestParameters.country, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get exemption requirements for region
     * @param {ExemptionRequirementsApiGetRegionRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRegionRequirements(requestParameters, options) {
        return ExemptionRequirementsApiFp(this.configuration).getRegionRequirements(requestParameters.country, requestParameters.region, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExemptionsApi - axios parameter creator
 */
export const ExemptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by country
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {boolean} [forceRecompute] Force recompute and update exemption ?  ⚠️ Only for **service** access.
         * @param {string} [sourceExemptionId] Exemption id that would be used as source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByCountry: async (accountId, country, forceRecompute, sourceExemptionId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createByCountry', 'accountId', accountId);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('createByCountry', 'country', country);
            const localVarPath = `/exemptions/{accountId}/{country}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (forceRecompute !== undefined) {
                localVarQueryParameter['forceRecompute'] = forceRecompute;
            }
            if (sourceExemptionId !== undefined) {
                localVarQueryParameter['sourceExemptionId'] = sourceExemptionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by geographical area
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {boolean} [forceRecompute] Force recompute and update exemption ?  ⚠️ Only for **service** access.
         * @param {string} [sourceExemptionId] Exemption id that would be used as source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByGeographicalArea: async (accountId, country, region, forceRecompute, sourceExemptionId, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createByGeographicalArea', 'accountId', accountId);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('createByGeographicalArea', 'country', country);
            // verify required parameter 'region' is not null or undefined
            assertParamExists('createByGeographicalArea', 'region', region);
            const localVarPath = `/exemptions/{accountId}/{country}/{region}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (forceRecompute !== undefined) {
                localVarQueryParameter['forceRecompute'] = forceRecompute;
            }
            if (sourceExemptionId !== undefined) {
                localVarQueryParameter['sourceExemptionId'] = sourceExemptionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by country
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCountry: async (accountId, country, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getByCountry', 'accountId', accountId);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getByCountry', 'country', country);
            const localVarPath = `/exemptions/{accountId}/{country}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by geographical area
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByGeographicalArea: async (accountId, country, region, options = {}) => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getByGeographicalArea', 'accountId', accountId);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getByGeographicalArea', 'country', country);
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getByGeographicalArea', 'region', region);
            const localVarPath = `/exemptions/{accountId}/{country}/{region}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a tax exemption record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExemptionById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExemptionById', 'id', id);
            const localVarPath = `/exemptions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get list of tax exemptions
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {Array<string>} [id] One tax exemption id or comma separated list
         * @param {Array<string>} [accountId] One account id or comma separated list
         * @param {Array<TaxExemptionType>} [type] Tax exemption type
         * @param {Array<TaxExemptionStatus>} [status] Tax exemption status
         * @param {Array<string>} [country] A single country code or a comma separated list
         * @param {Array<string>} [region] A single region code or a comma separated list
         * @param {Array<string>} [locationOriginalId] One or many comma separated originalId of the location the exemption applies to
         * @param {string} [sortBy] Field to sort by - defaults to sort by createdAt date
         * @param {PaginationOrder} [sortOrder] Sort order - defaults to descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExemptions: async (limit, offset, id, accountId, type, status, country, region, locationOriginalId, sortBy, sortOrder, options = {}) => {
            const localVarPath = `/exemptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (accountId) {
                localVarQueryParameter['accountId'] = accountId;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (country) {
                localVarQueryParameter['country'] = country;
            }
            if (region) {
                localVarQueryParameter['region'] = region;
            }
            if (locationOriginalId) {
                localVarQueryParameter['locationOriginalId'] = locationOriginalId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExemptionsApi - functional programming interface
 */
export const ExemptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExemptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by country
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {boolean} [forceRecompute] Force recompute and update exemption ?  ⚠️ Only for **service** access.
         * @param {string} [sourceExemptionId] Exemption id that would be used as source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createByCountry(accountId, country, forceRecompute, sourceExemptionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createByCountry(accountId, country, forceRecompute, sourceExemptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.createByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by geographical area
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {boolean} [forceRecompute] Force recompute and update exemption ?  ⚠️ Only for **service** access.
         * @param {string} [sourceExemptionId] Exemption id that would be used as source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createByGeographicalArea(accountId, country, region, forceRecompute, sourceExemptionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createByGeographicalArea(accountId, country, region, forceRecompute, sourceExemptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.createByGeographicalArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by country
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCountry(accountId, country, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCountry(accountId, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.getByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by geographical area
         * @param {string} accountId Account id
         * @param {string} country Must be a 2 letter country short-name code (ISO 3166 Alpha-2)
         * @param {string} region ISO 3166 Alpha-2 subdivision code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByGeographicalArea(accountId, country, region, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByGeographicalArea(accountId, country, region, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.getByGeographicalArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a tax exemption record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExemptionById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExemptionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.getExemptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get list of tax exemptions
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {Array<string>} [id] One tax exemption id or comma separated list
         * @param {Array<string>} [accountId] One account id or comma separated list
         * @param {Array<TaxExemptionType>} [type] Tax exemption type
         * @param {Array<TaxExemptionStatus>} [status] Tax exemption status
         * @param {Array<string>} [country] A single country code or a comma separated list
         * @param {Array<string>} [region] A single region code or a comma separated list
         * @param {Array<string>} [locationOriginalId] One or many comma separated originalId of the location the exemption applies to
         * @param {string} [sortBy] Field to sort by - defaults to sort by createdAt date
         * @param {PaginationOrder} [sortOrder] Sort order - defaults to descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExemptions(limit, offset, id, accountId, type, status, country, region, locationOriginalId, sortBy, sortOrder, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExemptions(limit, offset, id, accountId, type, status, country, region, locationOriginalId, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExemptionsApi.getExemptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ExemptionsApi - factory interface
 */
export const ExemptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExemptionsApiFp(configuration);
    return {
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by country
         * @param {ExemptionsApiCreateByCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByCountry(requestParameters, options) {
            return localVarFp.createByCountry(requestParameters.accountId, requestParameters.country, requestParameters.forceRecompute, requestParameters.sourceExemptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Create tax exemption by geographical area
         * @param {ExemptionsApiCreateByGeographicalAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByGeographicalArea(requestParameters, options) {
            return localVarFp.createByGeographicalArea(requestParameters.accountId, requestParameters.country, requestParameters.region, requestParameters.forceRecompute, requestParameters.sourceExemptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by country
         * @param {ExemptionsApiGetByCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCountry(requestParameters, options) {
            return localVarFp.getByCountry(requestParameters.accountId, requestParameters.country, options).then((request) => request(axios, basePath));
        },
        /**
         * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get tax exemption by geographical area
         * @param {ExemptionsApiGetByGeographicalAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByGeographicalArea(requestParameters, options) {
            return localVarFp.getByGeographicalArea(requestParameters.accountId, requestParameters.country, requestParameters.region, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a tax exemption record
         * @param {ExemptionsApiGetExemptionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExemptionById(requestParameters, options) {
            return localVarFp.getExemptionById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Get list of tax exemptions
         * @param {ExemptionsApiGetExemptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExemptions(requestParameters = {}, options) {
            return localVarFp.getExemptions(requestParameters.limit, requestParameters.offset, requestParameters.id, requestParameters.accountId, requestParameters.type, requestParameters.status, requestParameters.country, requestParameters.region, requestParameters.locationOriginalId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExemptionsApi - object-oriented interface
 */
export class ExemptionsApi extends BaseAPI {
    /**
     * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Create tax exemption by country
     * @param {ExemptionsApiCreateByCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createByCountry(requestParameters, options) {
        return ExemptionsApiFp(this.configuration).createByCountry(requestParameters.accountId, requestParameters.country, requestParameters.forceRecompute, requestParameters.sourceExemptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create tax exemption if it does not exist yet.  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_EXEMPTION_RECOMPUTE   * **Subroles:** BACKEND, DEVELOPER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Create tax exemption by geographical area
     * @param {ExemptionsApiCreateByGeographicalAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createByGeographicalArea(requestParameters, options) {
        return ExemptionsApiFp(this.configuration).createByGeographicalArea(requestParameters.accountId, requestParameters.country, requestParameters.region, requestParameters.forceRecompute, requestParameters.sourceExemptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Get tax exemption by country
     * @param {ExemptionsApiGetByCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByCountry(requestParameters, options) {
        return ExemptionsApiFp(this.configuration).getByCountry(requestParameters.accountId, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get existed tax exemption or compute one (without storing it).  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Get tax exemption by geographical area
     * @param {ExemptionsApiGetByGeographicalAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByGeographicalArea(requestParameters, options) {
        return ExemptionsApiFp(this.configuration).getByGeographicalArea(requestParameters.accountId, requestParameters.country, requestParameters.region, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Gets a tax exemption record
     * @param {ExemptionsApiGetExemptionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExemptionById(requestParameters, options) {
        return ExemptionsApiFp(this.configuration).getExemptionById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Get list of tax exemptions
     * @param {ExemptionsApiGetExemptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExemptions(requestParameters = {}, options) {
        return ExemptionsApiFp(this.configuration).getExemptions(requestParameters.limit, requestParameters.offset, requestParameters.id, requestParameters.accountId, requestParameters.type, requestParameters.status, requestParameters.country, requestParameters.region, requestParameters.locationOriginalId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthCheckApi - axios parameter creator
 */
export const HealthCheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Ensure the service is up and responding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: async (options = {}) => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthCheckApi - functional programming interface
 */
export const HealthCheckApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthCheckApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Ensure the service is up and responding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckApi.healthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HealthCheckApi - factory interface
 */
export const HealthCheckApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthCheckApiFp(configuration);
    return {
        /**
         *
         * @summary Ensure the service is up and responding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options) {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthCheckApi - object-oriented interface
 */
export class HealthCheckApi extends BaseAPI {
    /**
     *
     * @summary Ensure the service is up and responding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthCheck(options) {
        return HealthCheckApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location
         * @param {LocationsInput} locationsInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (locationsInput, options = {}) => {
            // verify required parameter 'locationsInput' is not null or undefined
            assertParamExists('createLocation', 'locationsInput', locationsInput);
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(locationsInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_DELETE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, INTENDED, SUSPENDED     * seller: ACTIVE, INTENDED, SUSPENDED     * service: ACTIVE, INTENDED, SUSPENDED </details>
         * @summary Deletes a location record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLocation', 'id', id);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a location record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationById', 'id', id);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * By default it searches for *active* and *not deleted* locations, if no **id** supplied. includeDeleted includes active and deleted locations if no **id** is supplied and isActive is unspecified. Specifying includeDeleted and isActive false returns inactive locations including deleted locations. The results are sorted by createdAt ascending. Response will have limited data returned if no token provided.   Overview of READ location permissions   - 2 projections: limited and full     - limited:         - a logged out user can see a limited projection when they query by a location Id     - full:         - a logged in user can see a full projection when they query with an id regardless of permissions         - a logged in user that do not query for specific location ids can see the full projections of all locations they have the LOCATION_LOCATION_READ_FULL permission   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_READ_FULL   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST, WAREHOUSE_MANAGER   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Find locations by query parameters
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {string} [originalId] Original id for the address
         * @param {Array<string>} [id] One location id or comma separated list
         * @param {Array<string>} [accountId] One account id or comma separated list
         * @param {Array<string>} [prettyId] One pretty id or comma separated list
         * @param {Array<string>} [enterpriseAddressId] One enterpriseAddressId or comma separated list
         * @param {Array<LocationAttribute>} [attributes] One attribute or comma separated list
         * @param {LocationType} [addressType] Location type
         * @param {string} [addressLine1] Case-insensitive partial search by Address line 1
         * @param {Array<string>} [addressName] One case-insensitive partial search by address name or a comma separated list. For a comma separated list, encoding required for address names with commas (Seattle Facility, WA -&gt; Seattle%20Facility%5C%2C%20WA)
         * @param {string} [city] City
         * @param {string} [provinceCode] Province code
         * @param {string} [zip] Zip code
         * @param {string} [countryCode] Country code
         * @param {boolean} [isActive] Filter by location active status. Default value is true, if no &#x60;id&#x60; provided
         * @param {boolean} [includeDeleted] Include deleted locations ? Default value false, if no &#x60;id&#x60; provided.
         * @param {boolean} [hasWarehouse] Filter by warehouse existence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (limit, offset, originalId, id, accountId, prettyId, enterpriseAddressId, attributes, addressType, addressLine1, addressName, city, provinceCode, zip, countryCode, isActive, includeDeleted, hasWarehouse, options = {}) => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (originalId !== undefined) {
                localVarQueryParameter['originalId'] = originalId;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (accountId) {
                localVarQueryParameter['accountId'] = accountId;
            }
            if (prettyId) {
                localVarQueryParameter['prettyId'] = prettyId;
            }
            if (enterpriseAddressId) {
                localVarQueryParameter['enterpriseAddressId'] = enterpriseAddressId;
            }
            if (attributes) {
                localVarQueryParameter['attributes'] = attributes;
            }
            if (addressType !== undefined) {
                localVarQueryParameter['addressType'] = addressType;
            }
            if (addressLine1 !== undefined) {
                localVarQueryParameter['addressLine1'] = addressLine1;
            }
            if (addressName) {
                localVarQueryParameter['addressName'] = addressName;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (provinceCode !== undefined) {
                localVarQueryParameter['provinceCode'] = provinceCode;
            }
            if (zip !== undefined) {
                localVarQueryParameter['zip'] = zip;
            }
            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (hasWarehouse !== undefined) {
                localVarQueryParameter['hasWarehouse'] = hasWarehouse;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts an array of locations to create instead of just a single one  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location for each location value in an array
         * @param {Array<MigrateLocations>} migrateLocations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateLocations: async (migrateLocations, options = {}) => {
            // verify required parameter 'migrateLocations' is not null or undefined
            assertParamExists('migrateLocations', 'migrateLocations', migrateLocations);
            const localVarPath = `/locations/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(migrateLocations, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_UPDATE_LIMITED   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_UPDATE_ENTERPRISEID   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_UPDATE_SKIP_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating location fields for a particular user
         * @param {string} id resource identifier - mongo id
         * @param {PartialLocationUpdateDto} partialLocationUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (id, partialLocationUpdateDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLocation', 'id', id);
            // verify required parameter 'partialLocationUpdateDto' is not null or undefined
            assertParamExists('updateLocation', 'partialLocationUpdateDto', partialLocationUpdateDto);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(partialLocationUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location
         * @param {LocationsInput} locationsInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(locationsInput, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(locationsInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_DELETE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, INTENDED, SUSPENDED     * seller: ACTIVE, INTENDED, SUSPENDED     * service: ACTIVE, INTENDED, SUSPENDED </details>
         * @summary Deletes a location record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a location record
         * @param {string} id resource identifier - mongo id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * By default it searches for *active* and *not deleted* locations, if no **id** supplied. includeDeleted includes active and deleted locations if no **id** is supplied and isActive is unspecified. Specifying includeDeleted and isActive false returns inactive locations including deleted locations. The results are sorted by createdAt ascending. Response will have limited data returned if no token provided.   Overview of READ location permissions   - 2 projections: limited and full     - limited:         - a logged out user can see a limited projection when they query by a location Id     - full:         - a logged in user can see a full projection when they query with an id regardless of permissions         - a logged in user that do not query for specific location ids can see the full projections of all locations they have the LOCATION_LOCATION_READ_FULL permission   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_READ_FULL   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST, WAREHOUSE_MANAGER   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Find locations by query parameters
         * @param {number} [limit] Number of records to return (max 100)
         * @param {number} [offset] Results offset, for pagination
         * @param {string} [originalId] Original id for the address
         * @param {Array<string>} [id] One location id or comma separated list
         * @param {Array<string>} [accountId] One account id or comma separated list
         * @param {Array<string>} [prettyId] One pretty id or comma separated list
         * @param {Array<string>} [enterpriseAddressId] One enterpriseAddressId or comma separated list
         * @param {Array<LocationAttribute>} [attributes] One attribute or comma separated list
         * @param {LocationType} [addressType] Location type
         * @param {string} [addressLine1] Case-insensitive partial search by Address line 1
         * @param {Array<string>} [addressName] One case-insensitive partial search by address name or a comma separated list. For a comma separated list, encoding required for address names with commas (Seattle Facility, WA -&gt; Seattle%20Facility%5C%2C%20WA)
         * @param {string} [city] City
         * @param {string} [provinceCode] Province code
         * @param {string} [zip] Zip code
         * @param {string} [countryCode] Country code
         * @param {boolean} [isActive] Filter by location active status. Default value is true, if no &#x60;id&#x60; provided
         * @param {boolean} [includeDeleted] Include deleted locations ? Default value false, if no &#x60;id&#x60; provided.
         * @param {boolean} [hasWarehouse] Filter by warehouse existence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(limit, offset, originalId, id, accountId, prettyId, enterpriseAddressId, attributes, addressType, addressLine1, addressName, city, provinceCode, zip, countryCode, isActive, includeDeleted, hasWarehouse, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(limit, offset, originalId, id, accountId, prettyId, enterpriseAddressId, attributes, addressType, addressLine1, addressName, city, provinceCode, zip, countryCode, isActive, includeDeleted, hasWarehouse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts an array of locations to create instead of just a single one  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location for each location value in an array
         * @param {Array<MigrateLocations>} migrateLocations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateLocations(migrateLocations, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateLocations(migrateLocations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.migrateLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_UPDATE_LIMITED   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_UPDATE_ENTERPRISEID   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_UPDATE_SKIP_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating location fields for a particular user
         * @param {string} id resource identifier - mongo id
         * @param {PartialLocationUpdateDto} partialLocationUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(id, partialLocationUpdateDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(id, partialLocationUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location
         * @param {LocationsApiCreateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(requestParameters, options) {
            return localVarFp.createLocation(requestParameters.locationsInput, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_DELETE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, INTENDED, SUSPENDED     * seller: ACTIVE, INTENDED, SUSPENDED     * service: ACTIVE, INTENDED, SUSPENDED </details>
         * @summary Deletes a location record
         * @param {LocationsApiDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(requestParameters, options) {
            return localVarFp.deleteLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Gets a location record
         * @param {LocationsApiGetLocationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById(requestParameters, options) {
            return localVarFp.getLocationById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * By default it searches for *active* and *not deleted* locations, if no **id** supplied. includeDeleted includes active and deleted locations if no **id** is supplied and isActive is unspecified. Specifying includeDeleted and isActive false returns inactive locations including deleted locations. The results are sorted by createdAt ascending. Response will have limited data returned if no token provided.   Overview of READ location permissions   - 2 projections: limited and full     - limited:         - a logged out user can see a limited projection when they query by a location Id     - full:         - a logged in user can see a full projection when they query with an id regardless of permissions         - a logged in user that do not query for specific location ids can see the full projections of all locations they have the LOCATION_LOCATION_READ_FULL permission   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_READ_FULL   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST, WAREHOUSE_MANAGER   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Find locations by query parameters
         * @param {LocationsApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(requestParameters = {}, options) {
            return localVarFp.getLocations(requestParameters.limit, requestParameters.offset, requestParameters.originalId, requestParameters.id, requestParameters.accountId, requestParameters.prettyId, requestParameters.enterpriseAddressId, requestParameters.attributes, requestParameters.addressType, requestParameters.addressLine1, requestParameters.addressName, requestParameters.city, requestParameters.provinceCode, requestParameters.zip, requestParameters.countryCode, requestParameters.isActive, requestParameters.includeDeleted, requestParameters.hasWarehouse, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts an array of locations to create instead of just a single one  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
         * @summary Create a new location for each location value in an array
         * @param {LocationsApiMigrateLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateLocations(requestParameters, options) {
            return localVarFp.migrateLocations(requestParameters.migrateLocations, options).then((request) => request(axios, basePath));
        },
        /**
         *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_UPDATE_LIMITED   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_UPDATE_ENTERPRISEID   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_UPDATE_SKIP_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
         * @summary Updating location fields for a particular user
         * @param {LocationsApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters, options) {
            return localVarFp.updateLocation(requestParameters.id, requestParameters.partialLocationUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_CREATE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Create a new location
     * @param {LocationsApiCreateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLocation(requestParameters, options) {
        return LocationsApiFp(this.configuration).createLocation(requestParameters.locationsInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_DELETE   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, INTENDED, SUSPENDED     * seller: ACTIVE, INTENDED, SUSPENDED     * service: ACTIVE, INTENDED, SUSPENDED </details>
     * @summary Deletes a location record
     * @param {LocationsApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLocation(requestParameters, options) {
        return LocationsApiFp(this.configuration).deleteLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Gets a location record
     * @param {LocationsApiGetLocationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLocationById(requestParameters, options) {
        return LocationsApiFp(this.configuration).getLocationById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * By default it searches for *active* and *not deleted* locations, if no **id** supplied. includeDeleted includes active and deleted locations if no **id** is supplied and isActive is unspecified. Specifying includeDeleted and isActive false returns inactive locations including deleted locations. The results are sorted by createdAt ascending. Response will have limited data returned if no token provided.   Overview of READ location permissions   - 2 projections: limited and full     - limited:         - a logged out user can see a limited projection when they query by a location Id     - full:         - a logged in user can see a full projection when they query with an id regardless of permissions         - a logged in user that do not query for specific location ids can see the full projections of all locations they have the LOCATION_LOCATION_READ_FULL permission   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_READ_FULL   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER, FINANCE, MEDIATION, LISTINGS_MANAGER, LISTINGS_SPECIALIST, WAREHOUSE_MANAGER   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Find locations by query parameters
     * @param {LocationsApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLocations(requestParameters = {}, options) {
        return LocationsApiFp(this.configuration).getLocations(requestParameters.limit, requestParameters.offset, requestParameters.originalId, requestParameters.id, requestParameters.accountId, requestParameters.prettyId, requestParameters.enterpriseAddressId, requestParameters.attributes, requestParameters.addressType, requestParameters.addressLine1, requestParameters.addressName, requestParameters.city, requestParameters.provinceCode, requestParameters.zip, requestParameters.countryCode, requestParameters.isActive, requestParameters.includeDeleted, requestParameters.hasWarehouse, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Accepts an array of locations to create instead of just a single one  <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED </details>
     * @summary Create a new location for each location value in an array
     * @param {LocationsApiMigrateLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateLocations(requestParameters, options) {
        return LocationsApiFp(this.configuration).migrateLocations(requestParameters.migrateLocations, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *   <details><summary><b>🔐 Permissions</b></summary> * LOCATION_LOCATION_UPDATE_LIMITED   * **Subroles:** BACKEND, ADMIN, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_MANAGER, ACCOUNT_OWNER   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_UPDATE_ENTERPRISEID   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED  * LOCATION_LOCATION_TAX_EXEMPTION_READ   * **Subroles:** BACKEND, ADMIN, DEVELOPER, CUSTOMER_SERVICE_MANAGER, CUSTOMER_SERVICE_REPRESENTATIVE, ACCOUNT_OWNER, FINANCE, MEDIATION   * **Statuses:**      * buyer: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * seller: INTENDED, ACTIVE, READ_ONLY, SUSPENDED     * service: INTENDED, ACTIVE, READ_ONLY, SUSPENDED  * LOCATION_LOCATION_UPDATE_SKIP_VALIDATION   * **Subroles:** BACKEND   * **Statuses:**      * buyer: ACTIVE, SUSPENDED, INTENDED     * seller: ACTIVE, SUSPENDED, INTENDED     * service: ACTIVE, SUSPENDED, INTENDED </details>
     * @summary Updating location fields for a particular user
     * @param {LocationsApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLocation(requestParameters, options) {
        return LocationsApiFp(this.configuration).updateLocation(requestParameters.id, requestParameters.partialLocationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map